module.exports = __webpack_public_path__ + "img/host2-sm.eb6cc4a0.png";